import { Box, Stack, Typography } from "@mui/material";
import { CheckboxInput } from "Components/Shared/Inputs/Form/CheckboxInput";
import type { VerificationFormFieldsProps as Props } from "Components/UserAccount/Shared/VerificationForm/types";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Account;

export const NaturalPersonVerificationFormFields = ({ control }: Props) => {
  const { t } = useResource();

  return (
    <Box component="fieldset" sx={{ all: "unset", display: "grid" }}>
      <Stack mb="1rem" gap={2}>
        <Stack mb={4} gap={1}>
          <CheckboxInput
            disabled
            control={control}
            name="isPoliticallyExposedPerson"
            label={t(COMPONENT_RESOURCES.PoliticallyExposed)}
          />
          <Typography>
            {t(Resources.Components.Shared.PoliticallyExposedDescription)}
          </Typography>
        </Stack>
        <CheckboxInput
          disabled
          label={t(COMPONENT_RESOURCES.NonEUPermanentResidence)}
          control={control}
          name="hasNonEUResidence"
        />
        <CheckboxInput
          disabled
          label={t(COMPONENT_RESOURCES.NonEUNationality)}
          control={control}
          name="hasNonEUNationality"
        />
      </Stack>
    </Box>
  );
};
